<template>
  <div class="c-table" ref="monitortable">
    <el-table class="common-el-table-styles" :data="data" :height="height" v-loading="loading" border stripe>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
      >
        <template slot-scope="scope">
          <div v-if="col.key === 'enable'">
            <Poptip confirm transfer :title="popTitleTxt(scope.row.enable)" @on-ok="switchPlan(scope.row)">
              <i class="cover-mask"></i>
              <i-Switch :value="scope.row.enable" size="small" :true-value="1" :false-value="0" />
            </Poptip>
          </div>
          <div v-else-if="col.key === 'ruleMsg'">
            <span class="block-span g-error-text">{{ scope.row['dataRange'] }}</span>
            <span class="block-span" v-for="(cond, i) in scope.row[col.key]" :key="i">{{ cond }}</span>
          </div>
          <div v-else-if="col.key === 'accountNum'">
            <el-button type="text" @click.prevent="getPlanIds(scope.row)">{{ scope.row[col.key] }}</el-button>
          </div>
          <div v-else-if="col.key === 'control'">
            <el-button type="text" @click="editClick(scope.row)">修改规则</el-button>
          </div>
          <div v-else-if="col.key === 'monitorTimes'">
            <span class="block-span g-error-text">{{ scope.row['alertType'] | alertType }}</span>
            <span class="block-span">{{ scope.row['monitorTimes'] | timeType }}</span>
          </div>
          <span v-else-if="col.key === 'ruleType'">{{ scope.row[col.key] | ruleType }}</span>
          <span v-else-if="col.key === 'ruleModifyTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
          <span v-else-if="col.key === 'enableModifyTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>

    <manage-adcount v-model="model" :selector="accountIds" :media-ids="[10, 16]" @on-select="handleChangeAccount" />
  </div>
</template>
<script>
import { isArray } from '@/common/js/utils'
import ManageAdcount from './manage-adcount.vue'

import { updateAdcountState, updateAdcountCount } from '@/api/tools.model'
export default {
  name: 'monitorTable',
  components: {
    ManageAdcount
  },
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    columns: {
      type: Array
    },
    height: {
      type: Number
    }
  },
  methods: {
    popTitleTxt(state) {
      const txt = state ? '关闭' : '开启'
      return `确定要${txt}此管控规则吗？`
    },
    switchPlan(row) {
      const { ruleId: id, enable } = row
      const changStat = enable ? 0 : 1
      updateAdcountState({
        ruleId: id,
        enable: changStat
      }).then((data) => {
        if (data) {
          this.$set(row, 'enable', changStat)
          this.$emit('on-refresh')
        }
      })
    },
    editClick(row) {
      const { ruleId: id } = row
      const query = { id, t: 'edit' }
      this.$router.push({ name: 'adcountwarnedit', query })
    },
    copyClick(row) {
      const { ruleId: id } = row
      this.$router.push({ name: 'adcountwarnadd', query: { id } })
    },
    getPlanIds(row) {
      const { accountIds, ruleId: id } = row
      this.accountIds = accountIds
      this.model = true // 显示弹窗
      this.ruleId = id
    },
    handleChangeAccount(accounts) {
      if (isArray(accounts) && this.ruleId) {
        updateAdcountCount({
          ruleId: this.ruleId,
          accountIds: accounts
        }).then((data) => {
          if (!data) return
          this.$emit('on-refresh')
        })
      }
    }
  },
  filters: {
    alertType(val) {
      let type
      switch (val) {
        case 1:
          type = '仅钉钉'
          break
        case 2:
          type = '仅邮件'
          break
        case 3:
          type = '邮件+钉钉'
          break
        default:
          type = '未启用'
          break
      }
      return type
    },
    timeType(val) {
      if (val === 1) return '每5分钟'
      else return ''
    },
    satisType(val) {
      if (val === 'all') return '全部条件'
      else return '任意条件'
    },
    ruleType(val) {
      if (val === 1) return '暂停计划'
      else return ''
    }
  },
  data() {
    return {
      model: null,
      ruleId: 0,
      accountIds: []
    }
  }
}
</script>
<style lang="scss" scoped>
.c-table {
  .block-span {
    display: block;
  }

  .ivu-poptip {
    position: relative;

    .cover-mask {
      display: inline-block;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      z-index: 3;
      cursor: pointer;
    }
  }
}
</style>
